<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container" style="height:2050px">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>

          <div id="right" style="float:right; width:47%; height:100%; margin-bottom:20px;">
            <v-slider4></v-slider4>
          </div>
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
          <div id="right2" style="float:right; width:47%; height:100%; margin-top: 5px ;margin-bottom:20px;">
            <v-slider5></v-slider5>
          </div>
          <div class="b-richtext">
            <p v-html="richText3"></p>
          </div>
          <div id="right3" style="float:right; width:47%; height:100%; margin-top: 5px;  margin-bottom:20px;">
            <v-slider6></v-slider6>
          </div>
          <div class="b-richtext">
            <p v-html="richText4"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
import Slider4 from '@/components/slider4/'// 引入slider组件
import Slider5 from '@/components/slider5/'// 引入slider组件
import Slider6 from '@/components/slider6/'
// 引入slider组件
export default {
  data () {
    return {
      richText: '',
      richText2: '',
      richText3: '',
      richText4: '',
    };
  },
  mounted () {
    this.richText = '<p style="margin-bottom : 40px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Shared Labs</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 0px; font-size: 16px;">Our shared laboratories at Minhang Base, about 18,000 ㎡ in total, consist of 5 biochemistry laboratories, 4 bioinformatics laboratories, and 4 biomedical manufacturing laboratories. </span></p>'
      + '<p style="margin-bottom : 2px"><span style="margin-left: 0px; font-size: 16px;">We Provide:</span></p>'
      + '<ul>' +
      '<li style="margin-left: 26px; margin-top: 0px; margin-right: 26px; font-size: 16px;">▶ Access to state-of-the art services and technology</li>' +
      '<li style="margin-left: 26px;margin-top: 5px; font-size: 16px;">▶ All-hours security & 24-hour access</li>' +
      '<li style="margin-left: 26px;margin-top: 5px; font-size: 16px;">▶ Printing and copying</li>' +
      '<li style="margin-left: 26px;margin-top: 5px; font-size: 16px;">▶ Meeting Rooms/Conference Halls</li>' +
      '<li style="margin-left: 26px;margin-top: 5px; font-size: 16px;">▶ Flexible workspace</li>' +
      '</ul>'
      +'<p style="margin-top:30px; margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/gxsys1_en.jpg" style="width: 880px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'


      + '<div id="left" style="margin-top:100px; float:left ; width:48%; margin-left: 6px;  height:250px;">'
      + '<p style="text-align: left; "><span style="font-size: 20px; ">▶  Bioinformatics Laboratories</span></p>'
      + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">We provide the office facilities required for computing terminals for operating staff and researchers. We offer various services including high-performance computing and data storage service.</span></p>'
      + '</div>';

    this.richText2 =
      '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'

      + '<div id="center" style="margin-top:100px; float:left ; width:48%; margin-left: 6px;  height:250px;">'
      + '<p style="text-align: left;  margin-top:20px "><span style="font-size: 20px; ">▶  Biomedical Manufacturing Laboratories</span></p>'
      + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">We provide flexible experimental space which meet the needs of different research groups, with precision instrumental design and processing as the core of the service.</span></p>'
      + '</div>';

    this.richText3 =
      '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'

      + '<div id="rightt" style="margin-top:100px; float:left ; width:48%; margin-left: 6px;  height:260px;">'
      + '<p style="text-align: left;  margin-top:20px "><span style="font-size: 20px; ">▶  Biochemistry Laboratories</span></p>'
      + '<p style="margin-bottom : 20px; text-align: justify"><span style="font-size: 16px; ">We provide laboratory benches, special laboratory cabinets, fume hoods, cell munipulation rooms, cold rooms, PCR rooms, Nitrogen supply, Purified water,etc. We offer shared equipment and instrumentation necessary for  biotech and life sciences research.</span></p>'
      + '</div>';

    this.richText4 ='<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>';
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
    "v-slider4": Slider4,
    "v-slider5": Slider5,
    "v-slider6": Slider6
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service11/en/index.vue